var _defs, _path, _circle, _path2, _circle2, _rect, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2bottom",
    "data-name": "2bottom",
    xmlns: "http://www.w3.org/2000/svg",
    width: 584,
    height: 125,
    viewBox: "0 0 584 125",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .home-bg-bottom-cls-1 {\n        fill: #d9d9d9;\n      }\n\n      .home-bg-bottom-cls-1, .home-bg-bottom-cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .home-bg-bottom-cls-2, .home-bg-bottom-cls-3 {\n        fill: #ee162d;\n      }\n\n      .home-bg-bottom-cls-3 {\n        opacity: 0.35;\n      }\n\n      .home-bg-bottom-cls-4 {\n        fill: #e9e293;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_11",
    "data-name": "Rectangle 2 copy 11",
    className: "home-bg-bottom-cls-1",
    d: "M1685.01,1555H1685a25,25,0,0,1-25-25v-16a40,40,0,0,0-80,0v91h-5v-91a45,45,0,0,1,90,0v16h0a20,20,0,0,0,20.01,20v0.05a19.882,19.882,0,0,0,19.99-19.78V1500h5v30.27A24.861,24.861,0,0,1,1685.01,1555Z",
    transform: "translate(-1126 -1459)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_15",
    "data-name": "Ellipse 1 copy 15",
    className: "home-bg-bottom-cls-2",
    cx: 581.5,
    cy: 40.5,
    r: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_13",
    "data-name": "Rectangle 2 copy 13",
    className: "home-bg-bottom-cls-3",
    d: "M1216,1509a40,40,0,0,0-80,0v96h-10v-96a50,50,0,0,1,100,0v11h-10v-11Z",
    transform: "translate(-1126 -1459)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_18",
    "data-name": "Ellipse 1 copy 18",
    className: "home-bg-bottom-cls-2",
    cx: 95,
    cy: 62,
    r: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy_5",
    "data-name": "Rectangle 3 copy 5",
    className: "home-bg-bottom-cls-4",
    x: 273,
    y: 62,
    width: 10,
    height: 84
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_16",
    "data-name": "Ellipse 1 copy 16",
    className: "home-bg-bottom-cls-2",
    cx: 278,
    cy: 62,
    r: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomGraph);
export default __webpack_public_path__ + "static/media/bottom-graph.c6ef4a98a2cd2d9b7df5b46ab72de35c.svg";
export { ForwardRef as ReactComponent };